import { trackExponeaEvent, trackingEvent } from '@notino/web-tracking';

import { getTrackingProductName } from '@utils/tracking';

import { dispatchEcommerceMessage } from '../../../messagingService';
import { EcommerceSectionNamespace, EItemGroup, TEcommerceItem } from '../../model';

export const trackAddToCartEvent = (product: TEcommerceItem, quantity: number) => {
  switch (product.group) {
    case EItemGroup.SERVICE:
      dispatchEcommerceMessage(
        trackingEvent({
          event: EcommerceSectionNamespace.EEcommerceEvent.ADD_TO_CART,
          product: {
            group: EItemGroup.SERVICE,
            product_code: product.productCode,
            product_name: product.productName,
            cart_type: product.cartType,
            full_price: product.fullPrice,
            quantity: quantity,
            price: product.price,
          },
          _clear: true,
        }),
      );
      break;

    case EItemGroup.FREE_GIFT:
      dispatchEcommerceMessage(
        trackingEvent({
          event: EcommerceSectionNamespace.EEcommerceEvent.ADD_TO_CART,
          product: {
            group: EItemGroup.FREE_GIFT,
            product_code: product.productCode,
            product_name: product.productName ?? '',
            brand_name: product.brandName ?? '',
            cart_type: product.cartType,
            full_price: product.fullPrice,
            quantity: quantity,
            price: product.price,
          },
          _clear: true,
        }),
      );
      break;

    case EItemGroup.UPSELLING:
    case EItemGroup.GIFT:
    case EItemGroup.PRODUCT:
      dispatchEcommerceMessage(
        trackingEvent({
          event: EcommerceSectionNamespace.EEcommerceEvent.ADD_TO_CART,
          product: {
            product_code: product.productCode,
            product_name: getTrackingProductName(product),
            brand_name: product.productName,
            primary_type: product.primaryCategories.type,
            primary_category: product.primaryCategories.category,
            primary_subcategory: product.primaryCategories.subCategory,
            quantity: quantity,
            kind: product.primaryCategories.kind,
            full_price: product.fullPrice,
            cart_type: product.cartType,
            list_position: product.listPosition,
            list_name: product.listName,
            group: product.group,
            price: product.price,
          },
          _clear: true,
        }),
      );
      dispatchEcommerceMessage(
        trackExponeaEvent({
          eventName: EcommerceSectionNamespace.EEcommerceExponeaEventName.CART_UPDATE,
          action: EcommerceSectionNamespace.EEcommerceCartActions.ADD,
          quantity: quantity,
          productId: product.productId.toString(),
        }),
      );
      break;
    default:
      return;
  }
};
